import { batch } from "react-redux";
import employeeApi from "../../api/rest/employeeApi";
import { ALERT_VARIANT, EResponseCode, RESPONSE_STATUS } from "../../const/dataEnum";
import { showAlert } from "../../lib/utilities";
import { ModalType, TabId, tableDetail } from "../../pages/ManageEmployee/enum";
import {
  hideModal,
  resetNewEmployee,
  setAuthRoles,
  setCompanies,
  setEmployees,
  setModalType,
  setNewEmployee,
  setPageIndex,
  setPractice,
  setResponseStatus,
  setRoleLevels,
  setTotalItem,
  showModal,
} from "../actions/manageEmployeeAction";
import { setDepartments } from "../actions/departmentAction";
import { companyBusiness } from "./companyBusiness";
import { authRoleBusiness } from "./authRoleBusiness";
import { departmentBusiness } from "./departmentBusiness";
import { roleLevelBusiness } from "./roleLevelBusiness";
import practiceBusiness from "./practiceBusiness";
import { userDepartmentIdSelector } from "../selectors/appStateSelector";
import { setAlert } from "../actions/alertModalStateAction";



export const getInitialData = () => async (dispatch) => {
  try {
    const companies = await dispatch(companyBusiness.getAllCompanies());
    const roleLevels = await dispatch(roleLevelBusiness.getAllRoleLevel());
    const authRoles = await dispatch(authRoleBusiness.getAllAuthRole());
    const departmentData = await dispatch(departmentBusiness.getAllDepartment(null));

    batch(() => {
      if (companies) {
        dispatch(setCompanies(companies));
      }
      if (roleLevels) {
        dispatch(setRoleLevels(roleLevels))
      }
      if (authRoles) {
        dispatch(setAuthRoles(authRoles));
      }
      if (departmentData) {
        dispatch(setDepartments(departmentData));
      }
    })
  } catch (error) {
    console.error("faied on get intial data :", error);
  }
}

export const getEmployee = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const employeeState = state?.manageEmployeeState;

    if (!employeeState) {
      console.warn("getEmployee: manageEmployeeState is null or undefined");
      return;
    }

    const { filterMap, sortValue, pageSize, pageNo, selectedTab } = employeeState;
    const shoulGetEmployeeActicve = selectedTab === TabId.ACTIVE_EMPLOYEE;
    dispatch(setResponseStatus(RESPONSE_STATUS.PENDING));

    let sortID = sortValue.sortBy;
    switch (sortValue.sortBy) {
      case tableDetail.DEPARTMENT.TITLE:
        sortID = tableDetail.DEPARTMENT.SORT;
        break;
      case tableDetail.PRACTICE.TITLE:
        sortID = tableDetail.PRACTICE.SORT;
        break;
      case tableDetail.ROLE_LEVEL.TITLE:
        sortID = tableDetail.ROLE_LEVEL.SORT;
        break;
      case tableDetail.STATUS.TITLE:
        sortID = tableDetail.STATUS.SORT;
        break;
      default:
        break;
    }

    const param = {
      // employee: employee,
      // periodId: periodId,
      // practiceId: practice,
      // projectId: project,
      // departmentId: department,
      fullname: filterMap?.fullName ? filterMap?.fullName : null,
      department: filterMap?.Department ? filterMap?.Department : null,
      practice: filterMap?.Practice ? filterMap?.Practice : null,
      company: filterMap?.Company ? filterMap?.Company : null,
      sortBy: sortID,
      sortType: sortValue.sortType,
      pageNo: pageNo,
      pageSize: pageSize,
      isActive: shoulGetEmployeeActicve,
    };

    const res = await employeeApi.getEmployee(param);

    if (res) {
      batch(() => {
        dispatch(setTotalItem(res.totalCount));
        dispatch(setEmployees(res.data));
        dispatch(setPageIndex(Math.ceil(res.totalCount / pageSize)))
      })
    } else {
      batch(() => {
        dispatch(setTotalItem(0));
        dispatch(setEmployees([]));
        dispatch(setPageIndex(0));
      })
    }

    dispatch(setResponseStatus(RESPONSE_STATUS.SUCCESS));
  } catch (error) {
    console.error('failed to get employee data :', error)
  }
};

export const addEmployee = (newEmployee) => async (dispatch) => {
  try {
    const employeeDto = {
      id: newEmployee?.id,
      fullName: newEmployee?.fullName,
      authRoleID: newEmployee?.authRoleID,
      userName: newEmployee?.userName,
      departmentID: newEmployee?.departmentID,
      practiceID: newEmployee?.practiceID,
      roleLevelID: newEmployee?.roleLevelID,
      roleDescription: newEmployee?.roleDescription,
      joinDate: newEmployee?.joinDate,
      companyID: newEmployee?.companyID,
      lastDay: newEmployee?.lastDay ? newEmployee?.lastDay : null,
      notes: newEmployee?.notes,
    }

    const res = await employeeApi.addEmployee(employeeDto);
    if (res.responseCode === EResponseCode.NO_ERROR) {
      await dispatch(getEmployee());
    }
    batch(() => {
      dispatch(hideModal());
      dispatch(resetNewEmployee());
    })
  } catch (error) {
    console.error('failed to add employee :', error)
  }
};

export const updateEmployee = (newEmployee) => async (dispatch) => {
  try {
    const employeeDto = {
    id: newEmployee?.id,
    fullName: newEmployee?.fullName,
    authRoleID: newEmployee?.authRoleID,
    userName: newEmployee?.userName,
    departmentID: newEmployee?.departmentID,
    practiceID: newEmployee?.practiceID,
    roleLevelID: newEmployee?.roleLevelID,
    roleDescription: newEmployee?.roleDescription,
    joinDate: newEmployee?.joinDate,
    companyID: newEmployee?.companyID,
    lastDay: newEmployee?.lastDay ? newEmployee?.lastDay : null,
    notes: newEmployee?.notes,
  };

  const res = await employeeApi.updateEmployee(employeeDto);
  if (res) {
      const isSuccess = res.responseCode === EResponseCode.NO_ERROR;

      dispatch(setAlert({
        show: true,
        variant: isSuccess ? ALERT_VARIANT.SUCCESS : ALERT_VARIANT.ERROR,
        message: res.message || (isSuccess ? "Employee updated successfully." : "Failed to update employee."),
      }));

      if (isSuccess) {
        await dispatch(getEmployee());
        batch(() => {
          dispatch(hideModal());
          dispatch(resetNewEmployee());
        });
      }
    }
  } catch (error) {
    console.error('failed to update employee :', error);
    dispatch(setAlert({
      show: true,
      variant: ALERT_VARIANT.ERROR,
      message: "An unexpected error occurred while trying to update the employee."
    }));
  }
};


export const deleteEmployee = (employee) => async (dispatch) => {
  try {
    const res = await employeeApi.deleteEmployee(employee);
    if (res) {
      if (res.responseCode === EResponseCode.NO_ERROR) {
        dispatch(
          setAlert({
            show: true,
            variant: ALERT_VARIANT.SUCCESS,
            message: "Employee deleted successfully.",
          })
        );
        await dispatch(getEmployee());
      } else {
        dispatch(
          setAlert({
            show: true,
            variant: ALERT_VARIANT.ERROR,
            message: res.message,
          })
        );
      }
    }
  } catch (error) {
    console.error('failed to delete employee :', error)
    dispatch(
      setAlert({
        show: true,
        variant: ALERT_VARIANT.ERROR,
        message: "An unexpected error occurred while trying to delete the employee.",
      })
    );
  }
}


export const openModal = (modalType, employee) => async (dispatch, getState) => {
  try {
    const state = getState();
    const userDeptId = userDepartmentIdSelector(state);
    let practices = [];

    batch(() => {
      if (modalType === ModalType.UPDATE) {
        dispatch(setNewEmployee(employee));
      }
      dispatch(setModalType(modalType));
      dispatch(showModal());
    });

    switch (modalType) {
      case ModalType.UPDATE: {
        practices = await dispatch(practiceBusiness.getPracticeByDeptId(employee?.departmentID));
        break;
      }
      default: {
        practices = await dispatch(practiceBusiness.getPracticeByDeptId(userDeptId));
        break;
      }
    }

    if (practices) {
      dispatch(setPractice(practices));
    }
  } catch (error) {
    console.error('failed to open modal :', error)
  }
}